import { render, staticRenderFns } from "./sjUnion.vue?vue&type=template&id=8bacc8c6&scoped=true"
import script from "./sjUnion.vue?vue&type=script&lang=js"
export * from "./sjUnion.vue?vue&type=script&lang=js"
import style0 from "./sjUnion.vue?vue&type=style&index=0&id=8bacc8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bacc8c6",
  null
  
)

export default component.exports